<nav>
  <img src="../assets/img/SELLO_TIGREROJO.png" style="width: 200px; height: 200px;" alt="TIGRE_ROJO" >
  <ul class="menu">
    <li><a [routerLink]="['inicio']">Tigre Rojo</a></li>
    <li><a [routerLink]="['sensei']">Sensei</a></li>
    <li><a [routerLink]="['horarios']">Horarios</a></li>
    <li><a [routerLink]="['fotos']">Fotografías</a></li>
    <li><a [routerLink]="['contactos']">Contactos</a></li>
  </ul>
</nav>
<div class="home">
  <router-outlet></router-outlet>
</div>